import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_DEADLOCK: unique symbol = symbolName("deadlock");
